import { Metamodel } from 'app/model/base/model';
import { AzureBlobFSLinkedService } from 'app/model/linkedservice/azure-blob-fs.linkedservice';
import { AdvancedStoreWriteSettings } from './advanced-store-write-settings';

@Metamodel.model({
    name: 'AzureBlobFSWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureBlobFSLinkedService)
    }
})
export class AzureBlobFSWriteSettings extends AdvancedStoreWriteSettings {
}
